export default () => (typeEventId: string) =>
  parseInt(typeEventId, 10) === 6
